import { MaterialInput } from 'app/components'
import * as React from 'react'
import { Button, Col, Form, FormGroup, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'

interface ICopyrightFooterProps {
  className?: string
}

class CopyrightFooter extends React.Component<ICopyrightFooterProps, {}> {
  render() {
    return (
      <section className={`padding-y ${this.props.className}`}>
        <div className="container">
          <section>
            <ul className="list-inline text-center">
              <li>
                <Link to="/legal-disclaimer">Legal Disclaimer</Link>&nbsp;&nbsp;|
              </li>
              <li>
                <Link to="/terms-of-use">Terms of Use</Link>&nbsp;&nbsp;|
              </li>
              <li>
                <Link to="/faq">FAQ</Link>
              </li>
            </ul>
          </section>

          <footer className="text-center">
            <small>&copy;2020 FoundationMark. All rights reserved.</small>
          </footer>
        </div>
      </section>
    )
  }
}

export {
  CopyrightFooter
}



// WEBPACK FOOTER //
// ./src/app/components/section/CopyrightFooter/index.tsx